export const lightGreyWithSmallIconCss = {
    "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#EBECF0",
    },
    "& .MuiSelect-icon": {
        fontSize: "14px",
    },
}